<template>
  <div class="home flex-wrap">
    <div
      v-if="
        userInfo.role == 9 ||
          userInfo.role == 10 ||
          userInfo.role == 30 ||
          userInfo.role == 31
      "
      class="home-left"
    >
      <div
        v-if="userInfo.role == 30 || userInfo.role == 9"
        class="home-main-box todo-box fn-hide"
      >
        <div class="title">待办事项</div>
        <div class="content flex-wrap">
          <router-link
            class="todo-item flex-wrap"
            to="/admin/order/orderSigningAudit"
          >
            <div class="fn-left img-wrap">
              <img src="@/assets/img/home_todo_item1.png" alt>
            </div>
            <div class="item-content">
              <div class="item-content-total">
                {{ dataInfo.wait_audit_number }}
              </div>
              <div class="item-content-name">签约待财务审核</div>
            </div>
          </router-link>
          <router-link
            class="todo-item flex-wrap"
            to="/admin/order/orderRefundAudit"
          >
            <div class="fn-left img-wrap">
              <img src="@/assets/img/home_todo_item2.png" alt>
            </div>
            <div class="item-content">
              <div class="item-content-total">
                {{ dataInfo.wait_audit_refund_number }}
              </div>
              <div class="item-content-name">退款待财务审核</div>
            </div>
          </router-link>
          <router-link
            class="todo-item flex-wrap"
            to="/admin/order/orderConvertedAudit"
          >
            <div class="fn-left img-wrap">
              <img src="@/assets/img/home_todo_item3.png" alt>
            </div>
            <div class="item-content">
              <div class="item-content-total">
                {{ dataInfo.wait_audit_adversion_number }}
              </div>
              <div class="item-content-name">内转待财务审核</div>
            </div>
          </router-link>
          <router-link
            v-if="userInfo.role == 9"
            class="todo-item flex-wrap"
            to="/admin/order/orderGiveAudit"
          >
            <div class="fn-left img-wrap">
              <img src="@/assets/img/home_todo_item4.png" alt>
            </div>
            <div class="item-content">
              <div class="item-content-total">
                {{ dataInfo.wait_audit_give_number }}
              </div>
              <div class="item-content-name">赠送待总部审核</div>
            </div>
          </router-link>
          <!-- <div class="todo-item flex-wrap" v-if="userInfo.role == 9">
            <div class="fn-left img-wrap">
              <img src="@/assets/img/home_todo_item5.png" alt />
            </div>
            <div class="item-content">
              <div class="item-content-total">{{dataInfo.wait_audit_suggestion_number}}</div>
              <div class="item-content-name">待处理意见反馈</div>
            </div>
          </div> -->
        </div>
      </div>
      <div class="home-main-box management-box">
        <div class="title flex-wrap">
          <div>
            经营概况
            <span>{{ dataInfo.notes }}</span>
          </div>
          <div class="options-list flex-wrap">
            <div class="options-item active">昨日</div>
            <div class="options-item">
              <router-link
                to="/admin/statistics/salesStatistics"
              >更多数据</router-link>
            </div>
          </div>
        </div>
        <div class="content flex-wrap">
          <div class="management-item-wrap">
            <div class="management-item blue">
              <div class="item-name">销售总额</div>
              <div class="item-total">
                <span>￥</span>
                {{ dataInfo.sales_total_price }}
              </div>
            </div>
          </div>
          <div class="management-item-wrap">
            <div class="management-item blue">
              <div class="item-name">退费总额</div>
              <div class="item-total">
                <span>￥</span>
                {{ dataInfo.back_total_price }}
              </div>
            </div>
          </div>
          <div class="management-item-wrap">
            <div class="management-item blue">
              <div class="item-name">总实收</div>
              <div class="item-total">
                <span>￥</span>
                {{ dataInfo.real_total_price }}
              </div>
            </div>
          </div>
          <div class="management-item-wrap">
            <div class="management-item cyan">
              <div class="item-name">到校人数</div>
              <div class="item-total">{{ dataInfo.to_school_count }}</div>
            </div>
          </div>
          <div class="management-item-wrap">
            <div class="management-item cyan">
              <div class="item-name">课耗人数</div>
              <div class="item-total">{{ dataInfo.class_consume }}</div>
            </div>
          </div>
          <div class="management-item-wrap">
            <div class="management-item cyan">
              <div class="item-name">流失人数</div>
              <div class="item-total">{{ dataInfo.loss_total_count }}</div>
            </div>
          </div>
          <div class="management-item-wrap">
            <div class="management-item green">
              <div class="item-name">新增leads</div>
              <div class="item-total">{{ dataInfo.new_leads_count }}</div>
            </div>
          </div>
          <div class="management-item-wrap">
            <div class="management-item green">
              <div class="item-name">上门量</div>
              <div class="item-total">{{ dataInfo.door_count }}</div>
            </div>
          </div>
        </div>
      </div>
      <!-- <div class="home-main-box menu-box">
        <div class="title">常用功能</div>
        <div class="content flex-wrap">
          <div class="menu-item fn-clear">
            <img class="fn-left" src="@/assets/img/home_menu_item1.png" alt>
            <span class="fn-left">
              <router-link to="/admin/order/orderSigning">签约查询</router-link>
            </span>
          </div>
          <div class="menu-item fn-clear">
            <img class="fn-left" src="@/assets/img/home_menu_item2.png" alt>
            <span class="fn-left">
              <router-link to="/admin/order/orderRefund">退款查询</router-link>
            </span>
          </div>
          <div class="menu-item fn-clear">
            <img class="fn-left" src="@/assets/img/home_menu_item3.png" alt>
            <span class="fn-left">
              <router-link to="/admin/users/studentList">学生管理</router-link>
            </span>
          </div>
          <div
            v-if="userInfo.role == 9 || userInfo.role == 30"
            class="menu-item fn-clear fn-hide"
          >
            <img class="fn-left" src="@/assets/img/home_menu_item4.png" alt>
            <span class="fn-left">
              <router-link to="/admin/combo/addCombo">新增套餐</router-link>
            </span>
          </div>
          <div class="menu-item fn-clear">
            <img class="fn-left" src="@/assets/img/home_menu_item5.png" alt>
            <span class="fn-left">
              <router-link to="/admin/instruction">操作指南</router-link>
            </span>
          </div>
        </div>
      </div> -->
    </div>
    <!-- <div class="home-right">
      <div class="home-main-box school-course-box">
        <div class="title flex-wrap">
          <div>商学院动态</div>
          <router-link
            class="more"
            to="/admin/tuolele/tuoleleIndex"
          >更多</router-link>
        </div>
        <div class="content">
          <div
            v-for="item in dataInfo.business_list"
            :key="item.id"
            class="school-course-item"
          >
            <div
              class="school-course-name one-text-cut"
              @click="toTuoleleDetails(item.id)"
            >
              {{ item.title }}
            </div>
          </div>
        </div>
      </div>
    </div> -->
    <!-- <el-dialog title="更新内容" :visible.sync="updateModalVisible">
      <div class="update-titile">{{ updateInfo.title }}</div>
      <div class="update-content" v-html="updateInfo.content" />
      <div slot="footer" class="dialog-footer">
        <el-button
          type="primary"
          @click="updateModalVisible = false"
        >我知道了</el-button>
      </div>
    </el-dialog> -->
  </div>
</template>

<script>
export default {
  name: 'Home',
  components: {},
  data() {
    return {
      userInfo: {},
      dataInfo: {},
      updateInfo: {},
      updateModalVisible: false
    }
  },
  computed: {},
  watch: {},
  mounted() {
    this.userInfo = localStorage.userInfo
      ? JSON.parse(localStorage.userInfo)
      : {}
    this.getToDoTasks()
    this.getVersionUpdateMessage()
  },
  methods: {
    async getToDoTasks() {
      const ret = await this.$http.getToDoTasks()
      if (ret.code == 200) {
        this.dataInfo = ret.data
      }
    },
    async getVersionUpdateMessage() {
      const ret = await this.$http.getVersionUpdateMessage()
      if (ret.code == 200) {
        this.updateInfo = ret.data
        if (this.updateInfo.content == '') {
          return false
        }
        if (this.userInfo.company_id != 1) {
          return
        }
        const updateId = this.updateInfo.id
        const isRead = localStorage.getItem('isRead')
        if (isRead == updateId) {
          return false
        }
        this.updateModalVisible = true
        localStorage.setItem('isRead', updateId)
      }
    },
    toTuoleleDetails(id) {
      this.$router.push({
        path: '/admin/tuolele/tuoleleCourseDetails',
        query: { id }
      })
    }
  }
}
</script>
<style lang="scss" scoped>
.home {
  .home-right {
    flex: 1;
    min-width: 300px;
  }
  .home-left {
    flex: 4;
    margin-right: 30px;
  }
  .home-main-box {
    background-color: #ffffff;
    box-shadow: 0px 6px 20px 0px #3a5798;
    border-radius: 10px;
    padding: 40px;
    margin-bottom: 30px;
    .title {
      margin-bottom: 30px;
      justify-content: space-between;
      font-size: 30px;
      color: $color_black;
      span {
        font-size: 14px;
        margin-left: 20px;
        color: $color_normal;
      }
    }
    .content {
      flex-wrap: wrap;
      justify-content: space-between;
    }
    &.management-box {
      padding-right: 20px;
      .options-list {
        height: 34px;
        align-items: flex-end;
        .options-item {
          margin-left: 10px;
          width: 80px;
          height: 30px;
          border-radius: 6px;
          border: solid 1px $color_normal;
          text-align: center;
          line-height: 30px;
          font-size: 14px;
          color: $color_normal;
          cursor: pointer;
          &.active {
            color: $color_blue;
            border: solid 1px $color_blue;
          }
          a {
            color: $color_normal;
          }
        }
      }
      .content {
        justify-content: flex-start;
        .management-item-wrap {
          min-width: 310px;
          width: 33.33%;
          box-sizing: border-box;
          padding-right: 20px;
          .management-item {
            height: 160px;
            margin-bottom: 20px;
            border-radius: 10px;
            color: #fff;
            box-sizing: border-box;
            padding: 30px 0 0 30px;
            font-size: 20px;
            .item-total {
              font-size: 40px;
              margin-top: 27px;
              span {
                font-size: 20px;
              }
            }
            &.blue {
              background-image: linear-gradient(
                135deg,
                #83baff 0%,
                #4c84ff 100%
              );
            }
            &.cyan {
              background-image: linear-gradient(
                135deg,
                #8ee4ee 0%,
                #55c4d9 100%
              );
            }
            &.green {
              background-image: linear-gradient(
                135deg,
                #caf0b1 0%,
                #99dc79 100%
              );
            }
          }
        }
      }
    }
    &.menu-box {
      .content {
        .menu-item {
          padding: 0 5px;
          height: 50px;
          line-height: 50px;
          font-size: 18px;
          color: $color_black;
          cursor: pointer;
          margin-bottom: 20px;
          img {
            width: 50px;
            height: 50px;
            margin-right: 20px;
          }
          a {
            color: $color_black;
          }
        }
      }
    }
    &.todo-box {
      .content {
        box-sizing: border-box;
        border: solid 1px #d9d9d9;
        border-radius: 10px;
        justify-content: flex-start;
        .todo-item {
          cursor: pointer;
          align-items: center;
          justify-content: center;
          position: relative;
          width: 25%;
          height: 140px;
          min-width: 234px;
          a {
            color: $color_black;
          }
          .item-content {
            overflow: hidden;
            text-align: center;
            .item-content-total {
              color: $color_blue;
              font-size: 40px;
              margin-bottom: 10px;
            }
            .item-content-name {
              color: $color_black;
              font-size: 16px;
            }
          }
          .img-wrap {
            width: 62px;
          }
        }
      }
    }
    &.school-course-box {
      .title {
        justify-content: space-between;
        margin-bottom: 10px;
        .more {
          font-size: 16px;
          color: $color_blue;
          line-height: 34px;
          cursor: pointer;
        }
      }
      .content {
        .school-course-item {
          padding: 25px 0;
          border-bottom: solid 1px #d9d9d9;
          cursor: pointer;
          .school-course-name {
            font-size: 16px;
            color: #333333;
            padding-left: 16px;
            position: relative;
            &:before {
              width: 6px;
              height: 6px;
              background-color: $color_blue;
              border-radius: 50%;
              content: "";
              position: absolute;
              left: 0;
              top: 50%;
              transform: translate(0, -50%);
            }
          }
          .school-course-content {
            font-size: 14px;
            color: $color_normal;
          }
        }
      }
    }
  }
  ::v-deep .el-dialog {
    width: 800px;
    box-shadow: 0px 6px 20px 0px rgba(148, 148, 148, 0.5);
    border-radius: 10px;
    .el-dialog__header {
      padding: 30px 35px 20px 20px;
      border-bottom: solid 1px #f5f5f5;
      .el-dialog__title {
        color: $color_blue;
        font-size: 22px;
      }
      .el-dialog__close {
        color: $color_blue;
        font-size: 20px;
      }
      .el-dialog__headerbtn {
        top: 31px;
        right: 35px;
      }
    }
    .el-dialog__body {
      padding: 30px 40px;
      font-size: 14px;
      color: $color_black;
      .update-titile {
        font-size: 16px;
        font-weight: bold;
        margin-bottom: 15px;
      }
      .update-content {
      }
    }
    .el-dialog__footer {
      text-align: left;
      padding: 40px;
    }
    .el-button {
      width: 134px;
      height: 40px;
    }
  }
}
</style>
